import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { useLanguage } from '@/providers/LanguageProvider';
import Edit from 'public/shared-icons/Edit.svg';

import { CustomButton } from '../common';
import { Icons } from '../icons';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface AppDropdownMenuProps {
  isPinned: boolean;
  onPinToggle: () => void;
  appName: string;
}

export const AppDropdownMenu: React.FC<AppDropdownMenuProps> = ({
  isPinned,
  onPinToggle,
  appName,
}) => {
  const { locale, messages } = useLanguage();
  const general = messages?.General;
  const router = useRouter();
  return (
    <DropdownMenu modal={true}>
      <DropdownMenuTrigger asChild>
        <CustomButton
          variant="ghost"
          className="invisible h-6 w-6 p-0 hover:bg-[#257C9D1F] focus:bg-[#257C9D1F] active:bg-[#257C9D29] disabled:bg-transparent group-hover:visible"
        >
          {Icons.Ellipses('text-white size-6')}
        </CustomButton>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="mt-1 min-w-24 rounded-sm bg-white text-h5 text-[#0A2D3A]"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
      >
        <DropdownMenuItem
          className="p-2 hover:bg-[#EDEBE9] focus:outline-none focus:ring-0"
          onClick={onPinToggle}
        >
          <div className="flex items-center gap-2">
            {isPinned ? Icons.Unpin('size-4') : Icons.Pin('size-4')}
            <span>{isPinned ? general?.unpin : general?.pin}</span>
          </div>
        </DropdownMenuItem>
        <DropdownMenuItem className="p-2 hover:bg-[#EDEBE9] focus:outline-none focus:ring-0">
          <button
            onClick={() => router.push(`/${locale}/apps/edit-app/${appName}`)}
            className="flex w-full items-center gap-2"
          >
            <Image src={Edit} alt="edit icon" className="h-4 w-4" />
            <span>{general?.edit}</span>
          </button>
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
